module.exports = __webpack_public_path__ + "static/media/d2.f39cc9c9.png";